import {Field, useFormikContext} from 'formik'
import {InputText} from '@/components/form/InputText'
import {Product} from '../../../../core/_models'
import {Card} from '@/components/Card'

const PricingCard = () => {
  const { values, setFieldValue } = useFormikContext()
  const product = values as Product
  return (
    <Card
      title='Pricing'
      collapsable={true}
      id='pricing'
      className="card mb-5 mb-xl-8"
    >
      <Field
        name="credits"
        type="text"
        component={InputText}
        label="Product sold price"
        description="The price must to be in credits."
        placeholder="100"
        required={true}
      />

      <div className={'row'}>
        <div className={'col-4'}>
          <Field
            name="publicPricing.amount"
            type="text"
            component={InputText}
            label="Product public price"
            description="The price must to be in real currency."
            placeholder="10"
            required={true}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFieldValue('publicPricing.amount', e.target.value)
              if (product.type === 'TYPE_GIFT_CARD') {
                setFieldValue('faceAmount', e.target.value)
              }
            }}
          />
        </div>
        <div className={'col-2'}>
          <Field
            name="publicPricing.currency"
            type="text"
            className="text-uppercase"
            component={InputText}
            label="Product public price"
            description="The public price currency."
            placeholder="EUR"
            required={true}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFieldValue('publicPricing.currency', e.target.value)
              if (product.type === 'TYPE_GIFT_CARD') {
                setFieldValue('faceCurrency', e.target.value)
              }
            }}
          />
        </div>

        <div className={'col-4'}>
          <Field
            name="faceAmount"
            type="text"
            component={InputText}
            label="Product Face price"
            description="Should be in real currency for Gift card or duration for Subscription card"
            placeholder="100"
            required={true}
            disabled={product.type === 'TYPE_GIFT_CARD'}
          />
        </div>
        <div className={'col-2'}>
          <Field
            name="faceCurrency"
            type="text"
            component={InputText}
            label="Product face currency"
            description="The public price currency."
            placeholder="EUR"
            required={true}
            disabled={product.type === 'TYPE_GIFT_CARD'}
          />
        </div>
      </div>
    </Card>
  )
}

export {PricingCard}
